import { Tooltip } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import { ListTree } from '@octopus-do/octopus-storybook/icons'
import { artBoardActions } from '@store/reducers/artboard'
import type { AppState } from '@store/types'
import type React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useArtboardMode } from '@/hooks'
import css from './styles.module.css'

// Replaces the search magnifier: the search field now lives inside the
// Structure panel, alongside the page tree.
//
// Unlike the magnifier this is not gated on edit access — finding a page in a
// large sitemap is what a viewer following a shared link needs most, and
// neither the jump nor the selection writes to the project.
export const StructureButton: React.FC = () => {
  const dispatch = useDispatch()

  const { seoMode } = useArtboardMode()

  const showStructure = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.showStructure
  )

  const handleClick = () => {
    dispatch(
      artBoardActions.showStructure({
        showStructure: !showStructure,
      })
    )
  }

  if (seoMode) {
    return null
  }

  return (
    <Tooltip content="Structure" wrap={false} tooltipClassName={css.tooltip}>
      <Button
        priority="secondary"
        size="medium"
        left={ListTree}
        aria-label="Structure"
        active={showStructure}
        data-testid="structure"
        onClick={handleClick}
      />
    </Tooltip>
  )
}
